import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { AvatarSmall, H3, PrimaryButton } from '../../../../components';

import CartListing from '../CartListing/CartListing';
import css from './CartCard.module.css';

/**
 * Seller card on the cart page.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
const CartCard = props => {
  const {
    group,
    selectedKeys,
    onSelectRow,
    onRemove,
    onCheckoutRow,
    onCheckoutGroup,
    layoutListingImageConfig,
  } = props;
  const validRows = group.rows.filter(row => !row.isStale);
  const staleCount = group.rows.length - validRows.length;
  const hasMultipleRows = group.rows.length > 1;

  return (
    <section className={css.root}>
      <header className={css.header}>
        <div className={css.sellerMeta}>
          <AvatarSmall className={css.avatar} disableProfileLink user={group.seller} />
          <div className={css.sellerText}>
            <p className={css.soldBy}>
              <FormattedMessage id="CartPage.soldBy" />
            </p>
            <H3 as="h2" className={css.heading}>
              {group.sellerName}
            </H3>
          </div>
        </div>
        {staleCount > 0 ? (
          <p className={css.warning}>
            <FormattedMessage id="CartPage.cardStaleWarning" values={{ count: staleCount }} />
          </p>
        ) : null}
      </header>

      <div className={css.rows}>
        {group.rows.map(row => (
          <CartListing
            hasMultipleRows={hasMultipleRows}
            key={row.key}
            layoutListingImageConfig={layoutListingImageConfig}
            onCheckout={() => onCheckoutRow(row)}
            onRemove={() => onRemove(row)}
            onSelect={checked => onSelectRow(row, checked)}
            row={row}
            selected={selectedKeys.has(row.key)}
          />
        ))}
      </div>

      <footer className={css.footer}>
        <p className={css.shippingCopy}>
          <span className={css.shippingLabel}>
            <FormattedMessage id="CartPage.shippingLabel" />
          </span>{' '}
          <FormattedMessage id="CartPage.shippingMessage" />
        </p>

        {hasMultipleRows ? (
          <PrimaryButton
            disabled={validRows.length === 0}
            onClick={onCheckoutGroup}
            rootClassName={css.checkoutSellerButton}
            type="button"
          >
            <FormattedMessage id="CartPage.checkoutSeller" />
          </PrimaryButton>
        ) : null}
      </footer>
    </section>
  );
};

export default CartCard;
